var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailgun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1144 21.933C27.8654 21.933 21.7475 27.7824 21.7475 35.2053C21.7152 38.7344 23.1131 42.1282 25.6269 44.6237C28.1408 47.1192 31.5595 48.5069 35.1144 48.4749C42.3635 48.4749 48.4786 42.6255 48.4786 35.2053C48.4786 27.7824 42.3635 21.933 35.1144 21.933ZM14.2728 34.9786C14.2728 23.7335 23.5611 14.5128 34.8888 14.5128C46.2136 14.5128 55.502 23.7335 55.502 34.9786C55.502 35.6534 55.502 36.555 55.2763 37.2298C55.0479 39.2515 56.6358 40.8251 58.6751 40.8251C62.074 40.8251 62.5253 36.555 62.5253 34.9786C62.5253 19.9086 50.0638 7.53788 34.8888 7.53788C19.7082 7.53788 7.25223 19.9086 7.25223 34.9786C7.25223 50.0513 19.7082 62.4192 34.8888 62.4192C43.0432 62.4192 50.2922 59.0451 55.2763 53.4226L60.9373 58.1463C54.8222 65.3453 45.3082 69.8451 35.1117 69.8451C25.7883 69.8738 16.8386 66.2088 10.2473 59.663C3.65599 53.1171 -0.032268 44.2312 0.000212727 34.9758C0.000212727 15.8597 15.6296 0.117676 35.1144 0.117676C54.3681 0.117676 70 15.8625 70 34.9813C70 42.6283 66.3755 48.9284 58.9008 48.9284C55.7276 48.9284 53.6911 47.352 52.5572 45.7784C48.9327 51.6277 42.3607 55.4498 34.886 55.4498C29.4126 55.4683 24.1581 53.318 20.2878 49.4759C16.4175 45.6338 14.2514 40.4176 14.27 34.9841L14.2728 34.9786ZM35.1117 28.9052C38.5105 28.9052 41.2296 31.6045 41.2296 34.9786C41.2296 38.3526 38.5105 41.052 35.1144 41.052C33.4898 41.0586 31.9298 40.4208 30.781 39.2804C29.6322 38.14 28.9898 36.5913 28.9965 34.9786C28.9965 31.6045 31.7156 28.9052 35.1144 28.9052H35.1117Z",
    fill: "#C02428"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailgun);
export default __webpack_public_path__ + "static/media/mailgun.281e805e415ecb3485b036246ab7e6aa.svg";
export { ForwardRef as ReactComponent };